import React from "react";
import Layout from "../layout/layout";

const Idupload = () => {
  return (
    <Layout>
      <div className="verification">
        <div className="container h-100">
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-xl-5 col-md-6">
              <div className="card">
                {/* <div class="card-header">
    <h4 class="card-title">Link a Debit card</h4>
</div> */}
                <div className="card-body">
                  <form
                    action="https://ekash.vercel.app/verifying-id.html"
                    className="identity-upload"
                  >
                    <div className="identity-content">
                      <h4>Upload your ID card</h4>
                      <span>(Driving License or Government ID card)</span>
                      <p>
                        Uploading your ID helps as ensure the safety and
                        security of your founds
                      </p>
                    </div>
                    <div className="mb-4">
                      <div className="d-flex justify-content-between mb-2">
                        <label className="form-label">Upload Front ID </label>
                        <span className="float-right">
                          Maximum file size is 2mb
                        </span>
                      </div>
                      <div className="file-upload-wrapper" data-text="404.html">
                        <input
                          name="file-upload-field"
                          type="file"
                          className="file-upload-field"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between mb-2">
                        <label className="form-label">Upload Back ID </label>
                        <span className="float-right">
                          Maximum file size is 2mb
                        </span>
                      </div>
                      <div
                        className="file-upload-wrapper"
                        data-text="404-2.html"
                      >
                        <input
                          name="file-upload-field"
                          type="file"
                          className="file-upload-field"
                        />
                      </div>
                    </div>
                    <div className="mt-5">
                      <button type="submit" className="btn btn-primary w-100">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Idupload;
